<template>
  <div>
    <v-dialog v-model="show" persistent fullscreen>
      <v-card>
        <v-app-bar dark text color="secondary">
          <page-header-title :title="$t('coursetemplates.available_course_templates')"></page-header-title>

          <v-spacer></v-spacer>

          <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 md3>
                  <v-text-field
                    :label="$t('global.search')"
                    v-model="search_params.any"
                    @keydown="checkKeyPress"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-select
                    v-model="search_params.filter"
                    :items="$dd_admin_course_templates_filter()"
                    item-text="text"
                    item-value="key"
                    :label="$t('enrolments.status')"
                    @change="filter"
                    hide-details
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 md3>
                  <v-select
                    v-model="search_params.type"
                    :items="[{ key: 'all', text: $t('global.dd_enrolment_list_status_all') }, ...$dd_course_templates_fixed_type()]"
                    item-text="text"
                    item-value="key"
                    :label="$t('coursetemplates.type')"
                    @change="filter"
                    hide-details
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 md3>
                  <v-autocomplete
                    v-model="search_params.coursetype_id"
                    :items="coursetypes"
                    item-text="fullname"
                    item-value="admin_id"
                    :label="$t('coursetypes.title')"
                    autocomplete="new-password"
                    @change="filter"
                    clearable
                  >
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>

          <action-button type="cancel" @click="cancel" />
          <action-button type="save" :text="$t('global.import')" @click="submit" :disabled="selected.length == 0" />
        </v-app-bar>

        <v-divider></v-divider>

        <v-card-text class="py-0 mt-4">
          <v-data-table
            :headers="headers"
            :items="coursetemplates"
            :items-per-page="coursetemplates.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            item-key="id"
            :show-select="true"
            v-model="selected"
            :expanded.sync="expanded"
            show-expand
            :must-sort="true"
          >
            <template v-slot:item.name="{ item }">
              {{ item.name }}
            </template>

            <template v-slot:item.coursetypegroup_id="{ item }">
              {{ item.coursetypegroup.full_name }}
            </template>

            <template v-slot:item.coursetype_id="{ item }">
              {{
                item.coursetypes && item.coursetypes.length > 0
                  ? item.coursetypes
                      .map(function (ct) {
                        return ct.name
                      })
                      .join(", ")
                  : null
              }}
            </template>

            <template v-slot:item.coursetemplatetype_id="{ item }">
              {{ $dd_course_templates_type(item.coursetemplatetype_id) }}
            </template>

            <template v-slot:item.status="{ item }">
              {{ $dd_course_templates_status(item.status) }}
            </template>

            <template v-slot:item.updated_at="{ item }">
              {{ moment.utc(item.updated_at).format(DATE_FORMAT + " " + TIME_FORMAT) }}
            </template>

            <template v-slot:expanded-item="{ item }">
              <td :colspan="6">
                <v-container grid-list-md class="mx-0 px-0 mt-0 pt-0">
                  <v-layout row wrap class="py-4">
                    <v-flex xs12 md6>
                      <v-text-field
                        :value="item.name"
                        :label="$t('coursetemplates.name')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        :value="item.certificate_display_name"
                        :label="$t('coursetemplates.certificate_display_name')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 lg6>
                      <v-textarea
                        :value="item.short_description"
                        rows="3"
                        auto-grow
                        :label="$t('coursetemplates.short_description')"
                        :readonly="true"
                        hide-details
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12 md6 lg6>
                      <v-textarea
                        :value="item.long_description"
                        rows="3"
                        auto-grow
                        :label="$t('coursetemplates.long_description')"
                        :readonly="true"
                        hide-details
                      ></v-textarea>
                    </v-flex>
                    <v-flex lg3 md4 sm6 xs12>
                      <v-text-field
                        :value="$dd_course_templates_type(item.coursetemplatetype_id)"
                        :label="$t('coursetemplates.coursetemplatetype_id')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg3 md4 sm6 xs12>
                      <v-text-field
                        :value="item.coursetypegroup.full_name"
                        :label="$t('coursetemplates.coursetemplatetype_id')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg3 md4 sm6 xs12>
                      <v-text-field
                        :value="
                          item.coursetypes
                            .map(function (ct) {
                              return ct.name
                            })
                            .join(', ')
                        "
                        :label="$t('coursetemplates.coursetype_id')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg3 md4 sm6 xs12>
                      <v-text-field
                        :value="$dd_course_templates_status(item.status)"
                        :label="$t('coursetemplates.status')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg2 md3 sm3>
                      <v-text-field
                        :value="item.valid_for"
                        :label="$t('coursetemplates.valid_for')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg2 md3 sm6 xs12>
                      <v-text-field
                        :value="item.price"
                        :label="$t('coursetemplates.price')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg2 md3 sm6 xs12>
                      <v-text-field
                        :value="item.price_proof"
                        :label="$t('coursetemplates.price_proof')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg2 md3 sm6 xs12>
                      <v-text-field
                        :value="item.price_vat"
                        :label="$t('coursetemplates.price_vat')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :value="item.info_link"
                        :label="$t('coursetemplates.info_link')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-card class="mt-4">
                    <v-app-bar dense text color="secondary">
                      <v-toolbar-title class="subheading">{{ $t("coursetemplates.pdf_template") }}</v-toolbar-title>
                    </v-app-bar>

                    <v-card-text class="pa-4">
                      <v-layout row wrap>
                        <v-flex xs12 lg5>
                          <v-text-field
                            :value="item.pdf_title"
                            :label="$t('coursetemplates.pdf_title')"
                            :readonly="true"
                            hide-details
                            autocomplete="new-password"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg7>
                          <v-text-field
                            :value="item.pdf_description"
                            :label="$t('coursetemplates.pdf_description')"
                            :readonly="true"
                            hide-details
                            autocomplete="new-password"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            :value="item.pdf_content"
                            rows="3"
                            auto-grow
                            :label="$t('coursetemplates.pdf_content')"
                            :readonly="true"
                            hide-details
                          ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>

                  <v-card class="mt-4">
                    <v-app-bar dense text color="secondary">
                      <v-toolbar-title class="subheading">{{ $t("moduletemplates.title") }}</v-toolbar-title>
                    </v-app-bar>
                    <v-card-text class="pa-4">
                      <v-layout row wrap>
                        <v-flex xs12 v-for="moduletemplate in item.moduletemplates" :key="moduletemplate.id">
                          <v-card>
                            <v-card-title class="body-1 mt-card-title">
                              <div class="body-2">{{ moduletemplate.name }}</div>
                              <div class="caption ml-2" v-if="!moduletemplate.is_included">
                                ({{ $t("moduletemplates.price") }}: {{ moduletemplate.price }})
                              </div>
                            </v-card-title>
                            <v-card-text>
                              <v-simple-table>
                                <template v-slot:default>
                                  <thead>
                                    <tr>
                                      <th class="text-left" width="40%">
                                        {{ $t("moduleoptions.name") }}
                                      </th>
                                      <th class="text-left" width="15%">
                                        {{ $t("moduleoptions.price") }}
                                      </th>
                                      <th class="text-left" width="15%">
                                        {{ $t("moduleoptions.hours") }}
                                      </th>
                                      <th class="text-left" width="15%">
                                        {{ $t("moduleoptions.enrol_select") }}
                                      </th>
                                      <th class="text-left" width="15%">
                                        {{ $t("moduleoptions.mandatory_accomplishment") }}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody v-for="moduleoption in moduletemplate.module_options" :key="moduleoption.id">
                                    <tr>
                                      <td scope="row" :class="moduleoption.comment ? 'py-2' : ''">
                                        {{ moduleoption.name }}
                                        <p v-if="moduleoption.comment" class="font-italic mb-0">( {{ moduleoption.comment }} )</p>
                                      </td>
                                      <td scope="row">{{ moduleoption.price }}</td>
                                      <td scope="row">{{ moduleoption.hours }}</td>
                                      <td scope="row">
                                        <v-simple-checkbox
                                          :value="Boolean(moduleoption.enrol_select)"
                                          :readonly="true"
                                          hide-details
                                        ></v-simple-checkbox>
                                      </td>
                                      <td scope="row">
                                        <v-simple-checkbox
                                          :value="Boolean(moduleoption.mandatory_accomplishment)"
                                          :readonly="true"
                                          hide-details
                                        ></v-simple-checkbox>
                                      </td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-container>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "AdminCourseTemplatesPopup",

  props: {
    show: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      url: "",
      selected: [],

      coursetemplates: [],
      coursetypes: [],

      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["start_datetime"],
        sortDesc: []
      },
      search_params: {
        name: "",
        status: 1,
        filter: "new-and-updated"
      },

      expanded: []
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: "", value: "data-table-expand" },
          { text: this.$t("coursetemplates.name"), value: "name" },
          { text: this.$t("coursetypegroups.title"), value: "coursetypegroup_id" },
          { text: this.$t("coursetypes.title"), value: "coursetype_id" },
          { text: this.$t("coursetemplates.updated"), value: "updated_at" }
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.refresh = true
      }
    },
    show: {
      handler(val) {
        if (val) {
          this.selected = []
          this.coursetemplates = []
          this.list()
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "coursetemplate/admintemplates"
  },

  created() {
    let lists = [{ key: "coursetypes", module: "coursetypes", query: "show_all=true" }]

    axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
      this.coursetypes = res.data.coursetypes
    })
  },

  methods: {
    list() {
      this.show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?" + query).then((res) => {
        this.coursetemplates = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false
        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    filter(target) {
      this.refresh = true
    },

    reset() {
      this.$refs.form.reset()
      this.refresh = true
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    },

    cancel() {
      this.$emit("callback_adminct_cancel")
    },

    submit() {
      let vm = this

      axios
        .post(this.API_URL + "coursetemplate/admintemplates/import", {
          ids: this.selected
            .map(function (ct) {
              return ct.id
            })
            .join(",")
        })
        .then((res) => {
          this.$awn.success(vm.$t("coursetemplates.import_success"))
          this.$emit("callback_adminct_submit", this.selected)
        })
        .catch((err) => {
          this.$awn.alert(vm.$t("coursetemplates.import_failed"))
        })
    }
  }
}
</script>

<style scoped></style>
